<script setup>

</script>

<template>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.3334 16.6667V3.33332C13.3334 2.8913 13.1578 2.46737 12.8453 2.15481C12.5327 1.84225 12.1088 1.66666 11.6667 1.66666H8.33341C7.89139 1.66666 7.46746 1.84225 7.1549 2.15481C6.84234 2.46737 6.66675 2.8913 6.66675 3.33332V16.6667" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M16.6667 5H3.33341C2.41294 5 1.66675 5.74619 1.66675 6.66667V15C1.66675 15.9205 2.41294 16.6667 3.33341 16.6667H16.6667C17.5872 16.6667 18.3334 15.9205 18.3334 15V6.66667C18.3334 5.74619 17.5872 5 16.6667 5Z" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>

</template>

<style scoped>

</style>